import { UseMutateAsyncFunction, useMutation } from "@tanstack/react-query";
import { FormCsvDataDto, UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_FORMS } from "../domain";

import { formsApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_IMPORT_CSV_DATA = "IMPORT_CSV_DATA";

const allowedRoles = [UserRole.Owner, UserRole.Manager, UserRole.Respondent];

type ImportFormCsvDataRequest = {
  formId: string;
  csvData: FormCsvDataDto[];
};

const importFormCsvData = async (req: ImportFormCsvDataRequest): Promise<void> => {
  await formsApi.formsControllerImportFormCsvData(req.formId, req.csvData);
};

export const useImportFormCsvData = (
  user: UserProfileDto | null,
): {
  importFormCsvDataAsync: UseMutateAsyncFunction<
    void,
    Error,
    ImportFormCsvDataRequest,
    unknown
  >;
  importFormCsvDataEnabled: boolean;
  isSuccessImportFormCsvData: boolean;
  isPendingImportFormCsvData: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);

  const { mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FORMS, ACTION_IMPORT_CSV_DATA],
    mutationFn: enabled ? importFormCsvData : undefined,
    onSuccess: () => {
      // TODO: solve reload
      // queryClient.invalidateQueries({
      //   queryKey: [DOMAIN_FORMS],
      // });
      // queryClient.invalidateQueries({
      //   queryKey: [DOMAIN_FORM_SUBMISSIONS],
      // });
      // queryClient.invalidateQueries({
      //   queryKey: [DOMAIN_FORM_SECTIONS_CONFIG],
      // });
      // TODO: reload page content only instead of the whole page
      window.location.reload();
    },
  });

  return {
    importFormCsvDataAsync: mutateAsync,
    importFormCsvDataEnabled: enabled,
    isSuccessImportFormCsvData: isSuccess,
    isPendingImportFormCsvData: isPending,
  };
};
